import { Button } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 30rem;
  gap: 3.4rem;
`;

export const StyledImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  inset: 0;
`;

export const StyledCtaTitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: 2.4rem;
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  line-height: 3.7rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.grey[100]};

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    font-size: ${({ theme }) => theme.fonts.sizes.subTitle};
  }
`;

export const StyledButton = styled(Button)`
  z-index: 1;

  && {
    &&:hover {
      color: ${({ theme }) => theme.colors.white};
    }
  }
`;
